<script setup lang="ts">
import { RouterView } from 'vue-router';
import AppLayout from '@/layouts/AppLayout.vue';
import MeetingDialog from '@/components/MeetingDialog.vue';
import { onMounted } from 'vue';
import { utmInit } from '@/helper/helper';
import { provideBrand } from '@/brands';

const brand = provideBrand();
document.title = brand.title;

const favicon = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
if (favicon) favicon.href = brand.favicon;

onMounted(async () => {
  utmInit();
});
</script>

<template>
  <div :class="brand.name + '-app'">
    <app-layout>
      <router-view />
      <notifications position="bottom center" />
    </app-layout>
    <meeting-dialog />
  </div>
</template>

<style scoped lang="scss"></style>
